import styles from './FJFooter.module.less';
import FJShareIcon from '../../../../../assets/svg/community/bottom-share.svg?react';
import FJLocalStore from '../../../../../store/FJLocalStore.js';
import FJRecreateIcon from '../../../../../assets/svg/community/recreate.svg?react';
import FJLikeIcon from '../../../../../assets/svg/community/bottom-like.svg?react';
import FJLikedIcon from '../../../../../assets/svg/community/bottom-liked.svg?react';
import FJMoreIcon from '../../../../../assets/svg/community/bottom-more.svg?react';
import FJDownloadIcon from '../../../../../assets/svg/download-black.svg?react';
import FJDropdownNew from '../../../../../common/components/FJDropDown/FJDropdownNew.jsx';
import FJToolTip from '../../../../../common/components/FJToolTip/FJToolTip.jsx';
import FJConstant from '../../../../../constants/FJConstant.js';

import FJDeleteIcon from '../../../../../assets/svg/community/bottom-delete.svg?react';
import FJReportIcon from '../../../../../assets/svg/community/report.svg?react';
import FJWarnIcon from '../../../../../assets/svg/community/warn.svg?react';
import FJButton from '../../../../../common/components/FJButton/FJButton.jsx';
import FJPrivacySetting from '../../../../FJCommunity/FJCommonComponent/FJPrivacySetting/FJPrivacySetting.jsx';
import FJShareSettingIcon from '../../../../../assets/svg/community/publish.svg?react';
import FJConfig from '../../../../../config/FJConfig.js';
import PropTypes from 'prop-types';
import { SHARE_LIST } from '../../../../../config/dataConfig/FJCommonDataConfig.js';
import { PUBLISH_TYPE } from '../../../../../config/dataConfig/FJCommunityData.js';
import FJUtil from '../../../../../util/FJUtil.js';
import { useRef } from 'react';

const FJFooter = props => {
    const { shareToSociety, onEdit, info, onDelete, onLike, onPrivacySettingChange, onReport, onDownload } = props;
    const {
        privacyStatus,
        isLike,
        likeNum,
        previewType = FJConstant.TOOL_PREVIEW,
        isCurrentUser = true,
        shareKey,
        communityId,
        type,
    } = info;

    const shareDropdownRef = useRef(null);

    const _onContactUs = () => {
        const shareLink = FJConfig.serverPath + `ai-share/${shareKey}.html`;
        localStorage.setItem('feedback-input', 'Questioned creation link: ' + shareLink);
        window.open(`/contact.html`, '_blank');
    };

    const _renderShareOverlay = ({ ref }) => {
        if (privacyStatus === 'down') {
            return (
                <div className={styles.report_box}>
                    <div className={styles.warn_box}>
                        <FJWarnIcon />
                    </div>

                    <div className={styles.title}>{FJLocalStore._('this-creation-was-reported')}</div>
                    <div className={styles.desc}>
                        {FJLocalStore._('this-creation-has-been-reported-and-is-currently-set-to-private')}
                    </div>
                    <FJButton
                        text={FJLocalStore._('contact-us')}
                        type='gradient'
                        className={styles.btn}
                        onClick={_onContactUs}
                    />
                </div>
            );
        }
        return (
            <div className={styles.share_box} ref={ref}>
                <div className={styles.share_title}>{FJLocalStore._('share')}</div>
                <div className={styles.share_content}>
                    {SHARE_LIST.map(item => (
                        <div
                            key={item.type}
                            className={styles.share_img_box}
                            onClick={() => {
                                shareToSociety && shareToSociety(item.type);
                                if (privacyStatus === PUBLISH_TYPE.PRIVATE) {
                                    shareDropdownRef.current?.hide();
                                }
                            }}
                        >
                            <item.newIcon />
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const _renderShareTrigger = ({ ref, onClick }) => {
        return (
            <FJToolTip title={'share'}>
                <div className={styles.icon_btn} ref={ref} onClick={onClick}>
                    <FJShareIcon />
                </div>
            </FJToolTip>
        );
    };

    const _renderMoreTrigger = ({ ref, onClick }) => {
        return (
            <div className={styles.icon_btn} ref={ref} onClick={onClick}>
                <FJMoreIcon />
            </div>
        );
    };

    const _renderMoreOverlay = ({ ref }) => {
        return (
            <div className={styles.more_box} ref={ref}>
                {previewType === FJConstant.COMMUNITY_PREVIEW && !isCurrentUser && (
                    <div className={styles.more_item} onClick={onReport}>
                        <FJReportIcon />
                        {FJLocalStore._('report')}
                    </div>
                )}
                {previewType === FJConstant.TOOL_PREVIEW && (
                    <div className={styles.more_item} onClick={onDelete}>
                        <FJDeleteIcon />
                        {FJLocalStore._('delete')}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className={styles.box}>
            <div className={styles.left}>
                {previewType === FJConstant.COMMUNITY_PREVIEW && (
                    <>
                        <FJDropdownNew
                            renderTrigger={_renderShareTrigger}
                            renderOverlay={_renderShareOverlay}
                            isTopLayer={true}
                            placement='topCenter'
                            trigger='click'
                            offsetTop={privacyStatus === 'down' ? -30 : -20}
                            ref={shareDropdownRef}
                        />
                        <div
                            className={styles.text_icon_btn}
                            onClick={() => {
                                onLike(!isLike);
                            }}
                        >
                            {isLike ? <FJLikedIcon /> : <FJLikeIcon />}
                            {likeNum}
                        </div>
                    </>
                )}
                {previewType === FJConstant.TOOL_PREVIEW && (
                    <>
                        <div className={styles.text_icon_btn} onClick={onEdit}>
                            <FJRecreateIcon />
                            {FJLocalStore._('recreate')}
                        </div>
                        {FJUtil.isEditPage() && (
                            <div className={styles.icon_btn} onClick={onDownload}>
                                <FJDownloadIcon />
                            </div>
                        )}
                        <FJDropdownNew
                            renderTrigger={_renderShareTrigger}
                            renderOverlay={_renderShareOverlay}
                            isTopLayer={true}
                            placement='topCenter'
                            trigger='click'
                            offsetTop={privacyStatus === 'down' ? -30 : -20}
                            ref={shareDropdownRef}
                        />
                        <FJPrivacySetting
                            value={privacyStatus}
                            onChange={onPrivacySettingChange}
                            isTopLayer={true}
                            placement='topCenter'
                            offsetTop={-10}
                            shareKey={shareKey}
                            communityId={communityId}
                            renderTrigger={({ ref, onClick }) => {
                                return (
                                    <div className={styles.icon_btn} ref={ref} onClick={onClick}>
                                        <FJShareSettingIcon />
                                    </div>
                                );
                            }}
                        />

                        {privacyStatus === PUBLISH_TYPE.PUBLIC && (
                            <div
                                className={styles.text_icon_btn}
                                onClick={() => {
                                    onLike(!isLike);
                                }}
                            >
                                {isLike ? <FJLikedIcon /> : <FJLikeIcon />}
                                {likeNum || 0}
                            </div>
                        )}
                    </>
                )}
            </div>

            {((previewType === FJConstant.COMMUNITY_PREVIEW && !isCurrentUser) ||
                previewType === FJConstant.TOOL_PREVIEW) &&
                type !== FJConstant.CREATIONS && (
                    <FJDropdownNew
                        renderTrigger={_renderMoreTrigger}
                        renderOverlay={_renderMoreOverlay}
                        isTopLayer={true}
                        placement='topRight'
                        trigger='click'
                        offsetTop={-10}
                    />
                )}
        </div>
    );
};
FJFooter.propTypes = {
    shareToSociety: PropTypes.func,
    onEdit: PropTypes.func,
    info: PropTypes.object,
    onDelete: PropTypes.func,
    onLike: PropTypes.func,
    onPrivacySettingChange: PropTypes.func,
    shareKey: PropTypes.string,
    onReport: PropTypes.func,
    onDownload: PropTypes.func,
};
export default FJFooter;
